<template>
  <div id="fm_display_simple">
    <el-row>
      <el-col :span="24">
        <fm_result_container :show_results_per_page_selector="show_results_per_page_selector" :resultColumns="resultColumns"></fm_result_container>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import ResultContainer from './ContainerResults.vue';

  export default {
    props: ['show_results_per_page_selector','resultColumns'],
    components: {
      'fm_result_container': ResultContainer
    },
    data(){
      return {

      }
    },
    methods: {

    },
    computed: {

    },
    created(){
      //set force fetch total results to true
      this.$store.dispatch('mppSetForceFetchTotalResults',true).then(response1 => {
        //console.log('value is set');
        //show animation + trigger the load of initial result data via ajax
        this.$store.dispatch('setMPPFetchingResultsNow', true);
        this.$store.dispatch('globalActionMPPFetchResults').then(response2 => {
          //console.log('results are fetched');

          //set total number of results value
          this.$store.dispatch('setNumTotalResults', response2.data.info.total_num_results)

          //set force fetch back to false to prevent rerunning this fetch all the time
          this.$store.dispatch('mppSetForceFetchTotalResults', false);
        });
      });
    }
  }
</script>

<style scoped lang="scss">

</style>